import React from 'react';
import cn from 'classnames';
import styles from './index.module.less'
import { IVariant } from 'base/interfaces/product';
import ReturnPolicyModal from '@app/product/ReturnPolicyModal';
import { LoopRender } from '@base/snippets/LoopRender';
import { useProdTips } from 'mod/product/useProdTips';

type IProps = {
    shownVariant: IVariant
}

const ProductTips: React.FC<IProps> = (props) => {
    const { shownVariant } = props
    const { list, returnPolicyVisible, closeReturnPolicy } = useProdTips(shownVariant);

    return (
        <>
            <LoopRender
                className={styles.tips}
                list={list}
                render={item => (
                    <div className={cn(styles.tip, 'flex')}>
                        <div className={styles.symbol}>
                            {item.icon}
                        </div>
                        <div className={'flex-1'}>
                            <div className={styles.title}>
                                {item.title}
                            </div>
                            {!!item.description && (
                                <div className={styles.desc}>
                                    {item.description}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            />

            {/* Return Policy 弹框*/}
            <ReturnPolicyModal
                visible={returnPolicyVisible}
                onClose={closeReturnPolicy}
            />
        </>
    )
}

export default React.memo(ProductTips);
